var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLeft32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21.512 3.488c.65.651.65 1.706 0 2.357L11.024 16.333l10.488 10.489a1.667 1.667 0 1 1-2.357 2.357L7.488 17.512a1.667 1.667 0 0 1 0-2.357L19.155 3.488c.65-.65 1.706-.65 2.357 0",
  clipRule: "evenodd"
})));
export default SvgIcLeft32;